import axios from 'axios';
import { acquireAppAccessToken } from "../auth/authService";

export interface MSGraphUser {
    businessPhones: string[]
    displayName: string
    givenName: string
    jobTitle: string
    mail: string
    mobilePhone: string
    officeLocation: string
    surname: string
    userPrincipalName: string
    id: string
}

const getPictureUrl = async (token: string) => {

    try {

        const pictureResponse = await axios.get("https://graph.microsoft.com/v1.0/me/photos/240x240/$value", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            responseType: 'arraybuffer'
        });

        const pictureBlob = new Blob([pictureResponse.data], {
            type: pictureResponse.headers["Content-Type"] as string
        });

        const pictureUrl = URL.createObjectURL(pictureBlob);

        return pictureUrl;
    } catch (e) {
        console.error("Failed to get profile picture.");
        console.error(e);
        return;
    }
}


export const getCurrentUser = async () => {

    const token = await acquireAppAccessToken("User.Read");

    const { data: user } = await axios.get<MSGraphUser>("https://graph.microsoft.com/v1.0/me", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    const pictureUrl = await getPictureUrl(token!);

    return { user, pictureUrl };
}